import React, { useEffect, useState } from 'react';
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers';
import { Link } from 'react-router-dom';

function CustomerCount() {
  const [customerCount, setCustomerCount] = useState(0);
  const [customerPackage, setCustomerPackage] = useState(0);
  const [displayCount, setDisplayCount] = useState(0);
  const [displayPackage, setDisplayPackage] = useState(0);

  useEffect(() => {
    const fetchCustomerCount = async () => {
      try {
        const response = await fetch("https://backendcway.causewaycargo.com/superadmin/todaybookingcount", {
          method: 'GET',
          headers: {
            'auth': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do',
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        console.log("today counts", result);

        const count = result.data || 0;
        const totalPackage = result.total_package || 0; 
        setCustomerCount(count);
        setCustomerPackage(totalPackage);
      } catch (error) {
        console.error('Error fetching customer count:', error);
      }
    };

    fetchCustomerCount();
  }, []);

  useEffect(() => {
    let start = 0;
    const duration = 7000;
    const increment = customerCount / (duration / 100);

    const updateCount = () => {
      start += increment;
      if (start >= customerCount) {
        setDisplayCount(customerCount);
      } else {
        setDisplayCount(Math.round(start));
        requestAnimationFrame(updateCount);
      }
    };

    if (customerCount > 0) {
      requestAnimationFrame(updateCount);
    }
  }, [customerCount]);

  useEffect(() => {
    let start = 0;
    const duration = 7000;
    const increment = customerPackage / (duration / 100);

    const updatePackage = () => {
      start += increment;
      if (start >= customerPackage) {
        setDisplayPackage(customerPackage);
      } else {
        setDisplayPackage(Math.round(start));
        requestAnimationFrame(updatePackage);
      }
    };

    if (customerPackage > 0) {
      requestAnimationFrame(updatePackage);
    }
  }, [customerPackage]);


  return (
    <div>
      <div className="rounded-3  px-8 py-10" style={{ height: '250px', backgroundColor: '#C42A21' }}>
        <div className="d-flex flex-column h-100 justify-content-between">
          <div className="d-flex justify-content-between align-items-start">
            <div>
              <h2 className="text-white mb-2" style={{ fontWeight: '600' }}>Today Bookings</h2>
              <p className="text-white-50 mb-0" style={{ fontSize: '0.95rem' }}>Updated just now</p>
            </div>
            <div className="text-end">
              <p className="text-white mb-0" style={{ fontWeight: '500' }}>Total Packages</p>
              <h4 className="text-white mb-0" style={{ fontSize: '1.5rem' }}>+{displayPackage}</h4>
            </div>
          </div>
          <div className="d-flex justify-content-start align-items-end">
            <h1 className="text-white display-1 mb-0" style={{ fontWeight: '700', fontSize: '5rem' }}>
              +{displayCount}
            </h1>
          </div>
        </div>
      </div>

      <div className='position-relative px-0 mt-8'>
        <div className='row g-0'>
          <div className='col px-6 py-10 rounded-2 me-7 mb-7' style={{ backgroundColor: '#FFFFFF' }}>
            <Link to='/customerTable' className='text-primary fw-bold fs-5' style={{ cursor: 'pointer', color: '#323C55' }}>
              {/* <KTSVG path='/media/icons/duotune/general/customer.svg' className='svg-icon-3x svg-icon-warning d-block my-2' /> */}
              <img alt='customer' src={toAbsoluteUrl('/media/icons/duotune/general/customer.svg')} className='svg-icon-3x svg-icon-warning d-block my-3' style={{ width: '32px' }} />
              Customers</Link>

          </div>
          <div className='col px-6 py-10 rounded-2 mb-7' style={{ backgroundColor: '#FFFFFF' }}>
            <Link to='/user/adduser' className='text-primary fw-bold fs-5' style={{ cursor: 'pointer' }}>
              {/* <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3x svg-icon-primary d-block my-2' /> */}
              <img alt='customer' src={toAbsoluteUrl('/media/icons/duotune/general/user.svg')} className=' svg-icon-warning d-block my-3' style={{ width: '32px' }} />
              New Users</Link>
          </div>
        </div>
        <div className='row g-0'>
          <div className='col px-6 py-10 rounded-2 me-7' style={{ backgroundColor: '#FFFFFF' }}>
            <Link to='/bookingtable' className='text-primary fw-bold fs-5' style={{ cursor: 'pointer' }}>
              <img alt='customer' src={toAbsoluteUrl('/media/icons/duotune/general/booking.svg')} className='svg-icon-3x svg-icon-warning d-block my-3' style={{ width: '32px' }} />
              Bookings
            </Link>
          </div>
          <div className='col px-6 py-10 rounded-2' style={{ backgroundColor: '#FFFFFF' }}>
            <Link to='/shipment' className='text-primary fw-bold fs-5' style={{ cursor: 'pointer' }}>
              <img alt='customer' src={toAbsoluteUrl('/media/icons/duotune/general/shipment.svg')} className='svg-icon-3x svg-icon-warning d-block my-3' style={{ width: '32px' }} />
              Shipments
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerCount;